import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import AuthorData = Backend.App.Data.Dashboard.Administration.AuthorData;
import Author = Backend.App.Resources.Dashboard.Administration.Author;
import {ListItem} from '../../../entities/list-item.entity';

@Injectable({providedIn: 'root'})
export class AuthorService extends BaseEndpointService<Author, AuthorData> {
  protected override endpoint = '/administration/authors';

  public override modelToMultiSelectItem(m: Author): ListItem & { model: Author; } {
    return {
      id: m.id,
      text: m.name ?? (m.team_member?.first_name ?? '') + ' ' + (m.team_member?.last_name ?? ''),
      isDisabled: false,
      model: m,
    }
  }
}
